import React, { useState } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  Modal,
  Button,
  TextField,
  Grid,
  Typography,
  Avatar,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@material-ui/core";
import ImageCropProfile from "../../../FormDialog/ImageCropProfile";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import RemoveProfilePic from "../../../FormDialog/RemoveProfilePic";
import api from "../../../../Axios/api";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import useStyles from "./styles";

import { useUserContext } from "../../../../context/UserContext";

export default function AddAdmin() {
  // Snackbar

  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };
  const classes = useStyles();

  // context
  const { store } = useUserContext();
  const token = store.data.token;

  ////////////////////image upload settings///////////////////
  const [isProfilePicRemove, setIsProfilePicRemove] = useState(false);
  const [profilePic, setProfilePic] = useState("");

  // image upload Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);

  const handleOpen = () => {
    setModelOpen(true);
  };

  const handleClose = () => {
    setModelOpen(false);
  };

  const onSelectlogo = (image) => {
    setProfilePic(image);
  };

  // Show delete ProfilePic dialog
  const handlerRemoveProfilePic = (e) => {
    e.preventDefault();
    setIsProfilePicRemove(true);
  };

  const confirmedRemoveProfilePic = () => {
    setProfilePic(null);
    setIsProfilePicRemove(false);
  };

  const initialValues = {
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    gender: "",
    CNIC: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Please Enter Name*"),
    email: Yup.string().email("please enter valid email").required("Required*"),
    phoneNumber: Yup.string()
      .min(11)
      .required("Please Enter The Contact number!!"),
    password: Yup.string().min(7).required("Required*"),
    CNIC: Yup.string().min(15).required("CNIC is required"),
    confirmPassword: Yup.string().oneOf(
      [Yup.ref("password"), null],
      "Passwords must match"
    ),
  });
  const onSubmit = (values, props) => {
    console.log(values);
    console.log("profile pic", profilePic);
    const { name, email, phoneNumber, password, birthday, CNIC } = values;
    api
      .post(
        "/superAdmin/register",
        {
          name,
          email,
          phoneNumber,
          password,
          CNIC,
          birthday,
          profilePic,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        console.log(res.data);
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Admin Added Successfully!",
          open: true,
        });
      })
      .catch((error) =>
        // console.log("ERROR: " + JSON.stringify(error.response.data.error))
        setSnackBar({
          ...snackBarstate,
          message: "ERROR: Fill all the fields first!!",
          type: "error",
          open: true,
        })
      );
  };

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={12} md={12} component={Paper}>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LibraryAddIcon />
          </Avatar>
          <Typography variant="h5">Add Admin</Typography>
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
          >
            {(props) => (
              <Form className={classes.form}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field
                      as={TextField}
                      autoFocus
                      margin="dense"
                      variant="outlined"
                      autoComplete="fName"
                      required
                      fullWidth
                      label="Full Name"
                      name="name"
                      helperText={<ErrorMessage name="name" />}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field
                      as={TextField}
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      label="Email"
                      id="email"
                      name="email"
                      helperText={<ErrorMessage name="email" />}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field
                      as={TextField}
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      placeholder="XXXXX-XXXXXXX-X"
                      label="CNIC"
                      name="CNIC"
                      helperText={<ErrorMessage name="CNIC" />}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field
                      as={TextField}
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      placeholder="Enter Contact"
                      label="Contact Number"
                      name="phoneNumber"
                      helperText={<ErrorMessage name="phoneNumber" />}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field
                      as={TextField}
                      type="password"
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      label="Password"
                      name="password"
                      helperText={<ErrorMessage name="password" />}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Field
                      as={TextField}
                      variant="outlined"
                      margin="dense"
                      type="password"
                      required
                      fullWidth
                      label="Confirm Password"
                      name="confirmPassword"
                      helperText={<ErrorMessage name="confirmPassword" />}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}></Grid>
                </Grid>
                {/*///////////////////////// image upload option /////////////////////////////*/}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  <Avatar
                    alt="profile photo"
                    src={profilePic}
                    className={classes.avatarInProfileSetting}
                  >
                    {"Pic HERE"}
                  </Avatar>
                  <div style={{ marginTop: 50 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleOpen}
                    >
                      <AddAPhotoIcon
                        style={{
                          marginRight: 5,
                          fontSize: 22,
                          marginBottom: 5,
                        }}
                      />
                      Upload
                    </Button>
                    <Button
                      onClick={handlerRemoveProfilePic}
                      style={{ color: "red" }}
                      color="red"
                    >
                      Remove Image
                    </Button>
                  </div>
                </div>

                <Button
                  size="large"
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Add Admin
                </Button>

                <RemoveProfilePic
                  RemoveProfilePic={isProfilePicRemove}
                  setRemoveProfilePic={setIsProfilePicRemove}
                  confirmedRemoveProfilePic={confirmedRemoveProfilePic}
                />
                <Snackbar
                  open={open}
                  anchorOrigin={{ vertical, horizontal }}
                  autoHideDuration={3000}
                  onClose={handleCloseSnackBar}
                  key={vertical + horizontal}
                >
                  <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleCloseSnackBar}
                    severity={snackBarstate.type}
                  >
                    {snackBarstate.message}
                  </MuiAlert>
                </Snackbar>
              </Form>
            )}
          </Formik>
        </div>
      </Grid>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFF",
            width: "70vw",
            height: "70vh",
            padding: "20px",
            position: "relative",
          }}
        >
          <ImageCropProfile
            onProfileChange={onSelectlogo}
            handleClose={handleClose}
          />
        </div>
      </Modal>
    </Grid>
  );
}
